import { ButtonPrimary } from "components/Atoms/Button";
import React, { useEffect } from "react";
import { PlaceholderContent } from "supportbeacon/articleplaceholders";
import { useApi } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { PreviewPanel, PreviewPanelContent, PreviewPanelFooter, PreviewPanelHeader } from "../PreviewPanel";
import { CompanyPreviewPanelContent } from "./CompanyPreviewPanelContent";

interface CompanyPreviewPanelProps {
  title: string
  companyId: number
  viewOnMap?: boolean
}

const CompanyPreviewPanel = (props: CompanyPreviewPanelProps) => {
  const { title, companyId, viewOnMap } = props;

  const api = useApi(() => window.CoreApi.Company.GetPreviewPanelData(companyId), ["company", companyId], {
    startEnabled: true
  });

  useEffect(() => {
    api.refetch();
  }, [companyId]);

  if (api.isInitialLoading) {
    return <>
      <PreviewPanelHeader title={title} />
      <PreviewPanelContent>
        <PlaceholderContent />
      </PreviewPanelContent>
      <PreviewPanelFooter />
    </>;
  }

  const company = api.data.data.company

  return <>
    <PreviewPanelHeader title={title} />
    <CompanyPreviewPanelContent
      company={company}
      viewOnMap={viewOnMap}

      onChange={async () => {
        await api.refetch()
      }}
    />
    <PreviewPanelFooter>
      <ButtonPrimary href={routes.company_Detail(companyId).absolute} label={RESX.Buttons.DetailView} />
    </PreviewPanelFooter>
  </>;
};

interface CompanyPreviewProps {
  companyId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const CompanyPreview = (props: CompanyPreviewProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`company-preview-${props.companyId}`}>
    <CompanyPreviewPanel
      title={RESX.Company.resxCompany}
      companyId={props.companyId}
      viewOnMap
    />
  </PreviewPanel>;
};

export const PromoterPreview = (props: CompanyPreviewProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`promoter-preview-${props.companyId}`}>
    <CompanyPreviewPanel
      title={site.currentEnvironment.functionGroups.promoter.singular}
      companyId={props.companyId}
    />
  </PreviewPanel>;
};

export const ArtistPreview = (props: CompanyPreviewProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`artist-preview-${props.companyId}`}>
    <CompanyPreviewPanel
      title={site.currentEnvironment.functionGroups.artist.singular}
      companyId={props.companyId}
    />
  </PreviewPanel>;
};
